import { z } from "zod";
import passwordSchema from "../../helpers/auth/passwordSchema";

export const adminResetUserPasswordSchema = z.object({
  customerId: z.string(),
  userId: z.string(),
  temporaryPassword: passwordSchema("Temporary password"),
});
export type AdminResetUserPasswordRequest = z.infer<
  typeof adminResetUserPasswordSchema
>;
